import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FilliereService {

  constructor(private http:HttpClient) { }
  fetchetfilliere(idetablissement:any){
    
    return this.http.get<any>(`${environment.apiUrl}/Filliere/${idetablissement}`);
  }
}
